/* ============================================
   GIGGLO.IN - Custom JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize all components
  initHeader();
  initMobileMenu();
  initProductCards();
  initCartDrawer();
  initQuantitySelectors();
  initSearchDrawer();
  initAnnouncementBar();
  initLazyLoading();
  initScrollAnimations();
});

/* ============================================
   HEADER
   ============================================ */
function initHeader() {
  const header = document.querySelector('.header');
  if (!header) return;

  let lastScroll = 0;
  const scrollThreshold = 100;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll > scrollThreshold) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }

    // Hide/show on scroll direction
    if (currentScroll > lastScroll && currentScroll > 200) {
      header.classList.add('header--hidden');
    } else {
      header.classList.remove('header--hidden');
    }

    lastScroll = currentScroll;
  });
}

/* ============================================
   MOBILE MENU
   ============================================ */
function initMobileMenu() {
  const toggle = document.querySelector('.header__menu-toggle');
  const menu = document.querySelector('.mobile-menu');
  const overlay = document.querySelector('.mobile-menu-overlay');
  const body = document.body;

  if (!toggle) return;

  toggle.addEventListener('click', () => {
    const isOpen = menu?.classList.contains('is-open');
    
    if (isOpen) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  });

  overlay?.addEventListener('click', closeMobileMenu);

  function openMobileMenu() {
    menu?.classList.add('is-open');
    overlay?.classList.add('is-visible');
    body.classList.add('no-scroll');
    toggle.classList.add('is-active');
  }

  function closeMobileMenu() {
    menu?.classList.remove('is-open');
    overlay?.classList.remove('is-visible');
    body.classList.remove('no-scroll');
    toggle.classList.remove('is-active');
  }
}

/* ============================================
   PRODUCT CARDS
   ============================================ */
function initProductCards() {
  const quickAddButtons = document.querySelectorAll('.product-card__quick-add');
  const wishlistButtons = document.querySelectorAll('.product-card__wishlist');

  // Quick Add to Cart
  quickAddButtons.forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = button.dataset.variantId;
      
      if (!variantId) return;

      button.classList.add('is-loading');
      button.textContent = 'Adding...';

      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (response.ok) {
          button.textContent = 'Added! ✓';
          updateCartCount();
          
          setTimeout(() => {
            button.textContent = 'Add to Cart';
            button.classList.remove('is-loading');
          }, 2000);
        } else {
          throw new Error('Failed to add');
        }
      } catch (error) {
        button.textContent = 'Error';
        setTimeout(() => {
          button.textContent = 'Add to Cart';
          button.classList.remove('is-loading');
        }, 2000);
      }
    });
  });

  // Wishlist Toggle
  wishlistButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      button.classList.toggle('is-active');
      
      // Save to localStorage
      const productId = button.dataset.productId;
      const wishlist = JSON.parse(localStorage.getItem('gigglo_wishlist') || '[]');
      
      if (button.classList.contains('is-active')) {
        if (!wishlist.includes(productId)) {
          wishlist.push(productId);
        }
      } else {
        const index = wishlist.indexOf(productId);
        if (index > -1) {
          wishlist.splice(index, 1);
        }
      }
      
      localStorage.setItem('gigglo_wishlist', JSON.stringify(wishlist));
    });
  });
}

/* ============================================
   CART FUNCTIONALITY
   ============================================ */
function initCartDrawer() {
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');

  cartToggle?.addEventListener('click', (e) => {
    e.preventDefault();
    openCartDrawer();
  });

  cartClose?.addEventListener('click', closeCartDrawer);
  cartOverlay?.addEventListener('click', closeCartDrawer);

  function openCartDrawer() {
    cartDrawer?.classList.add('is-open');
    cartOverlay?.classList.add('is-visible');
    document.body.classList.add('no-scroll');
    fetchCart();
  }

  function closeCartDrawer() {
    cartDrawer?.classList.remove('is-open');
    cartOverlay?.classList.remove('is-visible');
    document.body.classList.remove('no-scroll');
  }
}

async function fetchCart() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    renderCart(cart);
  } catch (error) {
    console.error('Error fetching cart:', error);
  }
}

function renderCart(cart) {
  const cartItems = document.querySelector('.cart-drawer__items');
  const cartTotal = document.querySelector('.cart-drawer__total-amount');
  const cartEmpty = document.querySelector('.cart-drawer__empty');
  const cartContent = document.querySelector('.cart-drawer__content');

  if (!cartItems) return;

  if (cart.item_count === 0) {
    cartEmpty?.classList.remove('hidden');
    cartContent?.classList.add('hidden');
    return;
  }

  cartEmpty?.classList.add('hidden');
  cartContent?.classList.remove('hidden');

  cartItems.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <div class="cart-item__image">
        <img src="${item.image}" alt="${item.title}" loading="lazy">
      </div>
      <div class="cart-item__details">
        <h4 class="cart-item__title">${item.title}</h4>
        <p class="cart-item__variant">${item.variant_title || ''}</p>
        <div class="cart-item__quantity">
          <button class="qty-btn qty-minus" data-key="${item.key}">-</button>
          <span class="qty-value">${item.quantity}</span>
          <button class="qty-btn qty-plus" data-key="${item.key}">+</button>
        </div>
      </div>
      <div class="cart-item__price">
        <span>₹${formatMoney(item.line_price)}</span>
        <button class="cart-item__remove" data-key="${item.key}">Remove</button>
      </div>
    </div>
  `).join('');

  if (cartTotal) {
    cartTotal.textContent = `₹${formatMoney(cart.total_price)}`;
  }

  // Add event listeners for quantity changes
  cartItems.querySelectorAll('.qty-minus').forEach(btn => {
    btn.addEventListener('click', () => updateCartItem(btn.dataset.key, -1));
  });

  cartItems.querySelectorAll('.qty-plus').forEach(btn => {
    btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 1));
  });

  cartItems.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', () => removeCartItem(btn.dataset.key));
  });
}

async function updateCartItem(key, change) {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const item = cart.items.find(i => i.key === key);
    
    if (item) {
      const newQuantity = Math.max(0, item.quantity + change);
      
      await fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: newQuantity
        })
      });

      fetchCart();
      updateCartCount();
    }
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

async function removeCartItem(key) {
  try {
    await fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    });

    fetchCart();
    updateCartCount();
  } catch (error) {
    console.error('Error removing cart item:', error);
  }
}

async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    const cartCounts = document.querySelectorAll('.header__cart-count');
    cartCounts.forEach(count => {
      count.textContent = cart.item_count;
      count.classList.toggle('hidden', cart.item_count === 0);
    });
  } catch (error) {
    console.error('Error updating cart count:', error);
  }
}

/* ============================================
   QUANTITY SELECTORS
   ============================================ */
function initQuantitySelectors() {
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('input');
    const minus = selector.querySelector('.qty-minus');
    const plus = selector.querySelector('.qty-plus');

    minus?.addEventListener('click', () => {
      const value = parseInt(input.value) || 1;
      if (value > 1) {
        input.value = value - 1;
        input.dispatchEvent(new Event('change'));
      }
    });

    plus?.addEventListener('click', () => {
      const value = parseInt(input.value) || 0;
      const max = parseInt(input.getAttribute('max')) || 999;
      if (value < max) {
        input.value = value + 1;
        input.dispatchEvent(new Event('change'));
      }
    });
  });
}

/* ============================================
   SEARCH
   ============================================ */
function initSearchDrawer() {
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchDrawer = document.querySelector('.search-drawer');
  const searchClose = document.querySelector('.search-drawer__close');
  const searchInput = document.querySelector('.search-drawer__input');

  searchToggle?.addEventListener('click', (e) => {
    e.preventDefault();
    searchDrawer?.classList.add('is-open');
    searchInput?.focus();
  });

  searchClose?.addEventListener('click', () => {
    searchDrawer?.classList.remove('is-open');
  });

  // Predictive search
  let searchTimeout;
  searchInput?.addEventListener('input', (e) => {
    clearTimeout(searchTimeout);
    const query = e.target.value;

    if (query.length < 2) {
      document.querySelector('.search-results')?.classList.add('hidden');
      return;
    }

    searchTimeout = setTimeout(() => {
      fetchSearchResults(query);
    }, 300);
  });
}

async function fetchSearchResults(query) {
  try {
    const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
    const data = await response.json();
    renderSearchResults(data.resources.results.products);
  } catch (error) {
    console.error('Search error:', error);
  }
}

function renderSearchResults(products) {
  const resultsContainer = document.querySelector('.search-results');
  if (!resultsContainer) return;

  if (!products || products.length === 0) {
    resultsContainer.innerHTML = '<p class="search-no-results">No products found</p>';
    resultsContainer.classList.remove('hidden');
    return;
  }

  resultsContainer.innerHTML = products.map(product => `
    <a href="${product.url}" class="search-result-item">
      <img src="${product.image}" alt="${product.title}" loading="lazy">
      <div class="search-result-info">
        <h4>${product.title}</h4>
        <span class="search-result-price">₹${formatMoney(product.price)}</span>
      </div>
    </a>
  `).join('');

  resultsContainer.classList.remove('hidden');
}

/* ============================================
   ANNOUNCEMENT BAR
   ============================================ */
function initAnnouncementBar() {
  const bar = document.querySelector('.announcement-bar');
  const closeBtn = document.querySelector('.announcement-bar__close');

  if (sessionStorage.getItem('announcement_closed')) {
    bar?.remove();
    return;
  }

  closeBtn?.addEventListener('click', () => {
    bar?.classList.add('is-hidden');
    sessionStorage.setItem('announcement_closed', 'true');
    setTimeout(() => bar?.remove(), 300);
  });
}

/* ============================================
   LAZY LOADING
   ============================================ */
function initLazyLoading() {
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.remove('lazy');
          observer.unobserve(img);
        }
      });
    });

    document.querySelectorAll('img.lazy').forEach(img => {
      imageObserver.observe(img);
    });
  }
}

/* ============================================
   SCROLL ANIMATIONS
   ============================================ */
function initScrollAnimations() {
  if ('IntersectionObserver' in window) {
    const animateObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      animateObserver.observe(el);
    });
  }
}

/* ============================================
   UTILITY FUNCTIONS
   ============================================ */
function formatMoney(cents) {
  return (cents / 100).toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Expose functions globally for Liquid templates
window.Gigglo = {
  updateCartCount,
  fetchCart,
  formatMoney
};
